export default __webpack_public_path__ + "static/media/InnivationLearningLogo.2acaf10d.png";